import styled from "styled-components";

export const SidebarControlContentActions = styled.div`
    margin: -0.25rem 0;

    display: flex;
    gap: 1rem;
`;
